/* eslint-disable import/prefer-default-export */
import Download from './components/Download.react';
import Lottie from './components/Lottie.react';
import Keyboard from './components/Keyboard.react';
import Monitor from './components/Monitor.react';
import Burger from './components/Burger.react';

export {
    Download,
    Lottie,
    Keyboard,
    Monitor,
    Burger
};
